export const Colors = {
    // Backgrounds colors

    BackgroundBlue: '#0C66E4',
    BackgroundLight: '#F7F9FC',
    BackgroundPrimary: '#E6ECF3',
    BackgroundWhite: '#FFFFFF',
    BackgroundSecondary: '#F8FAFB',
    BackgroundMango: '#FFC051',
    BackgroundWater: '#EBF2FD',
    BackgroundCatskillWhite: '#F2F4F8',
    BackgroundHoverBlue: '#d8e5fb',
    BackgroundGrayCircle: '#A3B2BD',
    BackgroundDisabled: '#4b5c6880',

    // Text colors

    TextPrimary: '#51566D',
    TextSecondary: '#4B5C68',
    TextWhite: '#FFFFFF',
    TextLight: '#51566D80',
    TextMiddleGray: '#4B5C68B3',
    TextLightGray: '#4B5C6880',
    TextGray: '#FFFFFF80',
    TextDarkGrey: '#2A374E80',
    TextCadetBlue: '#A3B2BD80',

    // Theme colors

    ThemeBlue: '#0C66E4',
    ThemeYellow: '#ECC711',
    ThemeGreen: '#00C851',
    ThemeRed: '#FE7070',
    ThemePurple: '#7B61EA',
    ThemeOrange: '#FFA330',
    ThemeGray: '#E6ECF380',
    ThemeBorder: '#51566DB3',
    ThemeMangoOrange: '#FE7B43',
};

export const Shadow = {
    normal: '0px 0px 12px #0052E01A',
    menuShadow: '0px 2px 6px #347af033',
    noteModalShadow: '0px 0px 6px #347AF033',
    modalShadow: '0px 0px 6px #8A8A8A29',
    changeShadow: '0px 0px 6px #8A8A8A3D',
    blueButton: '0px 0px 6px #347AF04D',
    tableTheadShadow: '0px 4px 2px #347af01a',
    theadRowBoxShadow: '0px 2px 6px rgba(52, 122, 240, 0.2)',
    tbodyRowBoxShadow: '0px 0px 6px rgba(138, 138, 138, 0.24)',
};

export const Backgrounds = {
    white: '#F7F9FC 0% 0% no-repeat padding-box',
    green: '#00C851 0% 0% no-repeat padding-box',
    gray: '#E6ECF3 0% 0% no-repeat padding-box',
    hover: '#26b85d 0% 0% no-repeat padding-box',
    whiteModal: '#FFFFFF 0% 0% no-repeat padding-box',
    tableActive: '#E6ECF380 0% 0% no-repeat padding-box',
    info: '#438AFE1A 0% 0% no-repeat padding-box',
    theme: '#438AFE 0% 0% no-repeat padding-box',
    themeDark: '#0000001A 0% 0% no-repeat padding-box',
    catskillWhite: '#F2F4F8 0% 0% no-repeat padding-box',
    darkBlue: '#337BEFFF',
    darkGrey: '#A3B2BD80',
    lightBlue: '#d8e5fb 0% 0% no-repeat padding-box',
    blue: '#347AF0 0% 0% no-repeat padding-box',
    blueHover: '#347AF0 0% 0% no-repeat padding-box',
    headerLightBlue: '#EBF2FD 0% 0% no-repeat padding-box',
    grayHover: '#EBF2FD80 0% 0% no-repeat padding-box;',
    Base: '#2A374E 0% 0% no-repeat padding-box',
};
